<template>
  <div class="text-start">
    <h2 class="card-title">Controls</h2>
    <p>
      Use the controls below to interact with the activity. Follow these steps
    </p>
    <h3>
      <i class="bi bi-hand-index-thumb"></i>
      Point-and-Click
    </h3>
    <ol class="list-group list-group-numbered mb-3">
      <li class="list-group-item">
        Click a activity button to execute and activity action.
      </li>
      <li class="list-group-item">
        Click the <strong>Next</strong> button to move on.
      </li>
    </ol>

    <h3>
      <i class="bi bi-keyboard"></i>
      Keyboard Navigation
    </h3>
    <ol class="list-group list-group-numbered border-3">
      <li class="list-group-item">
        Click <strong>tab</strong> to navigate through the activity actions.
      </li>
      <li class="list-group-item">
        Use the <strong>spacebar</strong> or <strong>enter</strong> to select an
        action.
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: "InstructionsComponent"
};
</script>
